<ng-container *ngIf="!isLoading; else formSkeleton">
  <kodit-racun-form-container [racunFormConfig]="racunFormConfig">
    <kodit-text-input-field
      dodatni-input
      formCtrlId="broj-fiskalnog-isecka"
      formCtrlLabel="Broj fiskalnog isečka"
      [formCtrl]="fakturaForm.controls.brojFiskalnogIsecka"
      [isVertial]="false"
      formCtrlLabelWidth="150px"
    ></kodit-text-input-field>
  </kodit-racun-form-container>
</ng-container>

<ng-template #formSkeleton>
  <div class="faktura-skeleton">

    <div class="fs-card">
      <div class="fs-row">
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
        <div class="fs-chip"></div>
      </div>
    </div>

    <div class="p-grid">
      <div class="p-col-6">
        <div class="fs-card fs-card--tall">
          <div class="fs-card-title"></div>
          <div class="fs-divider"></div>
          <div class="fs-fields">
            <div class="fs-field" *ngFor="let f of skeletonFields">
              <div class="fs-label"></div>
              <div class="fs-input"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-6">
        <div class="fs-card fs-card--tall">
          <div class="fs-card-title"></div>
          <div class="fs-divider"></div>
          <div class="fs-fields">
            <div class="fs-autocomplete"></div>
            <div class="fs-info-row">
              <div class="fs-info-label"></div>
              <div class="fs-info-value"></div>
            </div>
            <div class="fs-info-row">
              <div class="fs-info-label fs-info-label--short"></div>
              <div class="fs-info-value fs-info-value--long"></div>
            </div>
            <div class="fs-info-row">
              <div class="fs-info-label"></div>
              <div class="fs-info-value fs-info-value--medium"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-table">
        <div class="fs-table-head">
          <div class="fs-th fs-th--wide"></div>
          <div class="fs-th"></div>
          <div class="fs-th"></div>
          <div class="fs-th"></div>
          <div class="fs-th fs-th--wide"></div>
          <div class="fs-th fs-th--narrow"></div>
        </div>
        <div class="fs-table-row" *ngFor="let r of skeletonRows">
          <div class="fs-td fs-td--wide"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td"><div class="fs-bar"></div></div>
          <div class="fs-td fs-td--wide"><div class="fs-bar"></div></div>
          <div class="fs-td fs-td--narrow"><div class="fs-bar fs-bar--icon"></div></div>
        </div>
        <div class="fs-total-row">
          <div class="fs-total-label"></div>
          <div class="fs-total-value"></div>
        </div>
      </div>
    </div>

    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-row fs-row--wrap">
        <div class="fs-field-col" *ngFor="let f of skeletonRows">
          <div class="fs-field-label"></div>
          <div class="fs-input fs-input--wide"></div>
        </div>
      </div>
    </div>

    <div class="fs-card">
      <div class="fs-card-title"></div>
      <div class="fs-divider"></div>
      <div class="fs-textarea"></div>
      <div class="fs-textarea fs-textarea--short"></div>
    </div>

    <div class="fs-card fs-card--actions">
      <div class="fs-btn"></div>
      <div class="fs-btn fs-btn--primary"></div>
    </div>

  </div>
</ng-template>
